import styled, { css } from 'styled-components';

import Label from 'components/core/typography/Label';
import { Clickable, ClickableSurfaceCSS } from 'components/ui/shared/Buttons/Clickable';

import {
  BORDER_RADIUS_150,
  BORDER_RADIUS_200,
  HEIGHT_700,
  NEUTRAL_0,
  NEUTRAL_700,
  NEUTRAL_800,
  SPACE_150,
  SPACE_200,
  SPACE_300,
  SPACE_1000,
  Z_INDEX_3,
} from 'styles/tokens';

export const MultiNavLinkSubItemCSS = css`
  background-color: ${NEUTRAL_800};
  border-radius: ${BORDER_RADIUS_150};
  height: ${HEIGHT_700};
  padding: ${SPACE_150} ${SPACE_200} ${SPACE_300};

  ${Label} {
    color: ${NEUTRAL_0};
  }

  &.active {
    pointer-events: none;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${NEUTRAL_700};
  }
`;

export const MultiNavLinkSubItemsContainerCSS = css`
  display: none;
  left: ${SPACE_1000};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: ${Z_INDEX_3};
`;

export const navItemStyles = css`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const navItemSizeStyles = css`
  border-radius: ${BORDER_RADIUS_200};
  padding: ${SPACE_200};
`;

export const NavActionItem = styled(Clickable)`
  ${navItemStyles}
  ${navItemSizeStyles}
`;

/**
 * `NavActionItem`'s look on a plain box, for a nav item whose button is supplied by something
 * further out — a `MenuButton` trigger, say. Nesting `NavActionItem` inside one of those would put a
 * button inside a button.
 */
export const NavActionItemBox = styled.div`
  ${ClickableSurfaceCSS}
  ${navItemStyles}
  ${navItemSizeStyles}
`;
